import { OriginalArchivePanel } from "./media/OriginalArchivePanel";
import "./media/mediaIntegration.scss";
import React, { useState, useEffect } from "react";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import AppRoute from "./route/route";
import VerticalLayout from "./common/authLayout/VerticalLayout";
import NonAuthLayout from "./common/nonAuthLayout/NonAuthLayout";
import ScrollToTop from "./common/ScrollToTop";
import { publicRoutes, privateRoutes, karkhanaLegacyRoutes } from "./route/index";
import { ReactNotifications } from "react-notifications-component";
import { connect } from "react-redux";
// store
import { getApplication } from "./Store/application/actions";
import { getUsersPrpfileLogo } from "./Store/users/actions";
//css
import "./App.css";
import "./theme.scss";
const App = (props: any) => {
  const getLayout = () => {
    let layoutCls = VerticalLayout;
    return layoutCls;
  };
  const Layout = getLayout();

  return (
    <>
      <Router>
        <>
          <ScrollToTop />
          <ReactNotifications />
          <OriginalArchivePanel />
          <Switch>
          {/* Old Karkhana addresses (emails, bookmarks) move to the new ones before any guard runs. */}
          {karkhanaLegacyRoutes.map((route) => (
            <Route key={route.path} path={route.path} exact={route.exact} component={route.component} />
          ))}
          {publicRoutes.map((route, idx) => (
            <AppRoute
              path={route.path}
              exact={route.exact}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
            />
          ))}
          {privateRoutes?.map((route, idx) => (
            <AppRoute
              path={route.path}
              exact={route.exact}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
            />
          ))}
          </Switch>
        </>
      </Router>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, {
  getUsersPrpfileLogo,
  getApplication,
})(App);

